import { defineComponent as _defineComponent } from 'vue'
import { normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["id"]

import { ref, onMounted, watch } from 'vue'
import { createSpinner, showSpinner, hideSpinner } from '@syncfusion/ej2-popups'

// Props interface
interface SpinnerProps {
  isVisible: boolean
  target?: string
}

// Define props with defaults

export default /*@__PURE__*/_defineComponent({
  __name: 'Spinner',
  props: {
    isVisible: { type: Boolean },
    target: { default: 'spinner-container' }
  },
  setup(__props: any) {

const props = __props

// Template refs
const spinnerRef = ref<HTMLDivElement>()
const isInitialized = ref(false)

// Initialize spinner on component mount
onMounted(() => {
  if (spinnerRef.value && !isInitialized.value) {
    // Initialize spinner only once
    createSpinner({
      target: spinnerRef.value,
    })
    isInitialized.value = true
  }
})

// Watch for visibility changes
watch(() => props.isVisible, (newVisible) => {
  if (spinnerRef.value && isInitialized.value) {
    if (newVisible) {
      showSpinner(spinnerRef.value)
    } else {
      hideSpinner(spinnerRef.value)
    }
  }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    ref_key: "spinnerRef",
    ref: spinnerRef,
    id: _ctx.target,
    class: "e-spinner-overlay",
    style: _normalizeStyle({
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      zIndex: 1000,
      display: _ctx.isVisible ? 'block' : 'none'
    })
  }, null, 12, _hoisted_1))
}
}

})